module.exports = __webpack_public_path__ + "static/media/tour-compl-2.4f3c569c.png";